import { trackEvent } from '../trackEvent'

export const trackAllVaultsClickEvent = (subdomain: string) => {
  trackEvent({ event: 'See all vaults', params: { Subdomain: subdomain } })
}
